import { gsap } from 'gsap';

const mobileNav = document.querySelector('.mobile-nav');
const mobileNavInner = document.querySelector('.mobile-nav-inner');
const mobileButton = document.querySelector('.mobile-fixed-button button');
const subToggles = gsap.utils.toArray(mobileNav.querySelectorAll('.sub-menu-toggle'));

if (mobileNav) {
	mobileButton.onclick = e => {
		e.preventDefault();
		mobileNav.classList.toggle('--active');
		mobileButton.classList.toggle('--active');
		document.body.classList.toggle('hide-scroll');
		const visible = parseFloat(getComputedStyle(mobileNav).opacity);
		if(!visible){
			mobileNavInner.scrollTo({
				top: 0,
				behavior: 'instant',
			});
		}
	};

	subToggles.forEach(el => {
		const drawer = mobileNav.querySelector('#submenu-drawer-'+el.dataset.drawer);
		el.onclick = e => {
			e.preventDefault();
			el.classList.toggle('--active');
			drawer.classList.toggle('--active');
		};
	});
}

// const navbutton = document.querySelector('#navbutton');
// const mobileDraw = document.querySelector('#mobile-navigation-draw');

// if (navbutton) {
// 	navbutton.onclick = (e) => {
// 		e.preventDefault();
// 		mobileDraw.classList.toggle('reveal');
// 		document.body.classList.toggle('hide-scroll');
// 	};

// 	document.addEventListener('keydown', (evt) => {
// 		if (evt.key === 'Escape' || evt.keyCode === 27) {
// 			if (mobileDraw) {
// 				mobileDraw.classList.remove('reveal');
// 				document.body.classList.remove('hide-scroll');
// 			}
// 		}
// 	});

// 	// Select all submenu toggle links
// 	const submenuToggle = document.querySelectorAll('.submenu-drawer-toggle');

// 	// When a submenu toggle link is clicked
// 	submenuToggle.forEach((toggle) => {
// 		toggle.addEventListener('click', (e) => {
// 			e.preventDefault();

// 			// Get the ID of the drawer to toggle
// 			const drawerId = toggle.dataset.drawer;

// 			// Slide out any open drawers
// 			document.querySelectorAll('.submenu-drawer').forEach((drawer) => {
// 				drawer.classList.remove('open');
// 			});

// 			// Slide in the clicked drawer
// 			document.getElementById(drawerId).classList.add('open');
// 		});
// 	});

// 	// When the back link is clicked
// 	const backLink = document.querySelectorAll('.submenu-drawer-back');
// 	backLink.forEach((link) => {
// 		link.addEventListener('click', (e) => {
// 			e.preventDefault();

// 			// Slide out the current drawer
// 			link.closest('.submenu-drawer').classList.remove('open');
// 		});
// 	});

// 	// Get all the close buttons and attach event listeners
// 	const closeNavBtn = document.querySelector('#close-mobile-draw');
// 	if (closeNavBtn) {
// 		closeNavBtn.onclick = (e) => {
// 			e.preventDefault();
// 			mobileDraw.classList.remove('reveal');
// 			document.body.classList.remove('hide-scroll');
// 		};
// 	}
// }
